import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';
import StoreDetailsContext from '../../../context/StoreDetailsContext';
import { GENDER_FACETS } from '../../../tools/constants';

export default function GenderFacetInput({
  suggestedGender = '',
  userPrefGender = [],
}) {
  const { brand, store } = useContext(StoreDetailsContext);
  const genderValue = useMemo(() => {
    if (suggestedGender) return `gender:("${suggestedGender}")`;
    if (userPrefGender.length) return userPrefGender;
    return GENDER_FACETS?.[store]?.[brand] || '';
  }, [brand, store, suggestedGender, userPrefGender]);

  if (!genderValue) {
    return null;
  }

  return (
    <input
      data-testid="gender-facet-input"
      id="genderFacet"
      name="facet"
      type="hidden"
      value={genderValue}
    />
  );
}

GenderFacetInput.propTypes = {
  suggestedGender: PropTypes.string,
  userPrefGender: PropTypes.arrayOf(PropTypes.string),
};
